import { toast } from "react-toastify";

export const showMessage = (message: any, type: string) => {
    switch (type) {
        case "success":
            toast.success(message);
            break;
        case "info":
            toast.info(message);
            break;
        case "warning":
            toast.warning(message);
            break;
        case "error":
            toast.error(message);
            break;
        default:
            toast(message);
            break;
    }
};
